@if (!isFormEmailApi) {
    <h4 class="ticket-title" [innerHTML]="ticket.title | replaceEmojis: false : true"></h4>
} @else {
    <div #editorContainer class="editor-container">
        @if (!isEditorShown) {
            <h4
                (click)="showEditor()"
                #title
                class="ticket-title field-editable form-control"
                [innerHTML]="ticket.title | replaceEmojis: false : true"></h4>
        } @else {
            <form [ngClass]="{ 'submitted form-submitted': isSubmitted }">
                <textarea
                    type="text"
                    class="form-control d-none"
                    [formControl]="ticketTitle"
                    #titleEditorTextarea
                    autosize
                    [minRows]="1"
                    maxlength="147"
                    (keyup)="onKeyUp()"
                    (blur)="isUpdating || updateTitle($event)"
                    pattern="^(?!\s*$).+"
                    required>
                </textarea>
                <div class="buttons-block mt-1">
                    <button
                        type="button"
                        class="btn btn-sm btn-default me-1"
                        [disabled]="isUpdating"
                        (click)="hideEditor()"
                        translate>
                        Cancel
                    </button>
                    <button
                        type="submit"
                        class="btn btn-sm btn-primary"
                        [disabled]="isUpdating"
                        (click)="updateTitle()"
                        translate>
                        Save
                    </button>
                </div>
            </form>
        }
    </div>
}
